import React from 'react'

const Input = ({className, ...props}) => {
  return (
    <input
      className={`rounded border p-2 lg:p-4 ${className}`}
      style={{borderColor: '#ddd'}}
      {...props}
    />
  )
}

export { Input }